export default "- Your tax invoice\n- Your contract of sale\n- Our 3 month warranty\n- Your NRMA certificate\n";